import { setItemsRotation } from "store/actions";
import { appStore } from "store/store";
export class RotateItems {
    constructor(values) {
        this.executeRotations = {};
        this.undoRotations = {};
        values.forEach(value => {
            this.executeRotations[value.id.id] = value.rotation;
            this.undoRotations[value.id.id] = value.originalRotation;
        });
    }
    execute() {
        appStore.dispatch(setItemsRotation(this.executeRotations));
    }
    undo() {
        appStore.dispatch(setItemsRotation(this.undoRotations));
    }
}
